if (!customElements.get("hero-slider")) {
  customElements.define(
    "hero-slider",
    class HeroSlider extends HTMLElement {
      constructor() {
        super();
        this.slider = null;
      }

      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {
        this.slider.destroy(true, true);
      }

      init() {
        this.slider = new Swiper(this, {
          loop: false,
          centerMode: false,
          autoplay: {
            delay: 3000
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            1540: {
              centeredSlides: true,
              slidesPerView: 'auto',
              spaceBetween: 30
            },
            767: {
              centeredSlides: true,
              slidesPerView: 1,
              spaceBetween: 10
            }
          }
        });

        this.slider.on('slideChange', () => {
          this.handleSlideChange();
        });
      }

      handleSlideChange() {
        const activeSlide = this.slider.slides[this.slider.activeIndex];
        const color = activeSlide.dataset.color;
        const arrows = this.querySelectorAll('.swiper-button-next, .swiper-button-prev');
        arrows.forEach(arrow => {
          arrow.style.backgroundColor = color;
        });
        const paginationBullets = this.querySelectorAll('.swiper-pagination-bullet');
        paginationBullets.forEach(bullet => {
          bullet.style.background = color;
        });
      }
    }
  );
}